// GENERATED by scripts/client/sync.ts — do not edit
import { type ComponentType, type LazyExoticComponent, lazy } from 'react';
import type { ModuleId } from '@/modules/registry';

/** The pages this build contains: the client's enabled modules (client.config.ts). */
export const MODULE_PAGES: Partial<Record<ModuleId, LazyExoticComponent<ComponentType>>> = {
	fleet: lazy(() => import('@/pages/fleet-page').then((m) => ({ default: m.ProFleetPage }))),
	single: lazy(() => import('@/pages/single-page').then((m) => ({ default: m.ProSinglePage }))),
	assets: lazy(() => import('@/pages/assets-page').then((m) => ({ default: m.ProAssetsPage }))),
	topology: lazy(() =>
		import('@/pages/topology-page').then((m) => ({ default: m.ProTopologyPage })),
	),
	monitor: lazy(() => import('@/pages/monitor-page').then((m) => ({ default: m.ProMonitorPage }))),
	forecast: lazy(() =>
		import('@/pages/forecast-page').then((m) => ({ default: m.ProForecastPage })),
	),
	anomaly: lazy(() => import('@/pages/anomaly-page').then((m) => ({ default: m.ProAnomalyPage }))),
	solutions: lazy(() =>
		import('@/pages/solutions-page').then((m) => ({ default: m.ProSolutionsPage })),
	),
	predictive: lazy(() =>
		import('@/pages/predictive-page').then((m) => ({ default: m.ProPredictivePage })),
	),
	oman: lazy(() => import('@/pages/oman-page').then((m) => ({ default: m.ProOmanPage }))),
	rendiconto: lazy(() =>
		import('@/pages/rendiconto-page').then((m) => ({ default: m.ProRendicontoPage })),
	),
	warranty: lazy(() =>
		import('@/pages/warranty-page').then((m) => ({ default: m.ProWarrantyPage })),
	),
	roles: lazy(() => import('@/pages/roles-page').then((m) => ({ default: m.ProRolesPage }))),
	reports: lazy(() => import('@/pages/reports-page').then((m) => ({ default: m.ProReportsPage }))),
	config: lazy(() => import('@/pages/config-page').then((m) => ({ default: m.ProConfigPage }))),
};
